(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    /**
   * Check if DMO data contains a COLLECTIONS type offer
   * @returns {boolean} True if there's a COLLECTIONS offer in the DMO data
   */
  function hasCollectionsOffer() {
    // Check if window.data exists and has the expected structure
    if (!window.data?.theme?.productOffer) {
      return false;
    }

    const productOffer = window.data.theme.productOffer;

    // Handle case where productOffer is an array (invalid format)
    if (Array.isArray(productOffer)) {
      return false;
    }

    // Check if offers array exists
    if (!productOffer.offers || !Array.isArray(productOffer.offers)) {
      return false;
    }

    // Check if there's a COLLECTIONS type offer
    return productOffer.offers.some(offer => offer.type === 'COLLECTIONS');
  }

  /**
   * Check if we're on a product, collection, or offers page with collections
   * @returns {boolean} True if we're on a page where cart should persist
   */
  function isCartPersistencePage() {
    const pathname = window.location.pathname;

    // Check if we're on a product page
    if (pathname.includes('/products/')) {
      return true;
    }

    // Check if we're on collections listing page or a specific collection page
    if (pathname.includes('/collections')) {
      return true;
    }

    // Check if we're on offers page with COLLECTIONS type offer
    if (pathname.includes('/pages/offers') || pathname.includes('/pages/offer-app')) {
      return hasCollectionsOffer();
    }

    return false;
  }

  /**
   * Wait for window.data to be available (DMO data loaded)
   * @param {number} timeout - Maximum time to wait in milliseconds
   * @returns {Promise<boolean>} True if data is available, false if timeout
   */
  function waitForDMOData(timeout = 5000) {
    return new Promise((resolve) => {
      // If data already exists, resolve immediately
      if (window.data?.theme?.productOffer) {
        resolve(true);
        return;
      }

      const startTime = Date.now();
      const checkInterval = setInterval(() => {
        if (window.data?.theme?.productOffer) {
          clearInterval(checkInterval);
          resolve(true);
        } else if (Date.now() - startTime > timeout) {
          clearInterval(checkInterval);
          resolve(false);
        }
      }, 100);
    });
  }

  /**
   * Clear cart on every page load/refresh
   * Skips clearing on product, collection, and offers pages (with collections)
   */
  async function clearCartOnLoad() {
    const pathname = window.location.pathname;

    // For offers pages, wait for DMO data before deciding
    if (pathname.includes('/pages/offers') || pathname.includes('/pages/offer-app')) {
      const dataLoaded = await waitForDMOData();
    }

    // Don't clear cart on product, collection, and offers pages with collections
    if (isCartPersistencePage()) {
      return;
    }

    try {
      // Only clear when the cart contains ONLY auto-added items and no real products/bundles.
      // Never clear if there are real items (bundle products, regular purchases).
      const cartCheckResponse = await fetch('/cart.js');
      if (!cartCheckResponse.ok) return;
      const cart = await cartCheckResponse.json();
      if (!cart.items || cart.items.length === 0) return;

      const hasRealItems = cart.items.some(item => !item.properties?._auto_added);
      if (hasRealItems) return; // Real products present — never clear

      const hasAutoAddedOnly = cart.items.some(item => item.properties?._auto_added === 'true');
      if (!hasAutoAddedOnly) return; // Nothing to clear

      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Failed to clear cart');
      }

      const clearedCart = await response.json();

      // Dispatch cart update event to update UI
      const cartUpdateEvent = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: clearedCart,
          sourceId: 'cart-clear-on-load',
          data: {
            source: 'cart-clear-on-load',
            itemCount: 0,
            didError: false
          }
        }
      });
      document.dispatchEvent(cartUpdateEvent);

    } catch (error) {
      // Error handling - fail silently
    }
  }

  // Execute cart clear on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearCartOnLoad);
  } else {
    clearCartOnLoad();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    /**
   * Apply free pricing display to app-only and free trial products
   * Shows "FREE" with crossed-out original price
   */
  function applyAppOnlyFreePrice() {
    const priceContainers = document.querySelectorAll('.cart-item-price-container');

    priceContainers.forEach((container, index) => {
      const isAppOnly = container.dataset.isAppOnly === 'true';
      const isFreeTrial = container.dataset.isFreeTrial === 'true';
      const isAutoAdded = container.dataset.isAutoAdded === 'true';
      const originalPrice = parseInt(container.dataset.originalPrice);

      if (isAppOnly || isFreeTrial || isAutoAdded) {
        const finalPriceEl = container.querySelector('.cart-item-final-price');
        const originalPriceEl = container.querySelector('.cart-item-original-price');

        if (finalPriceEl && !finalPriceEl.classList.contains('cart-item-free-price')) {
          finalPriceEl.textContent = window.cartTranslations?.free || 'FREE';
          finalPriceEl.classList.add('cart-item-free-price');
        }

        // Hide any existing strikethrough prices for auto-added items
        if (originalPriceEl && isAutoAdded) {
          originalPriceEl.style.display = 'none';
        }
      }
    });
  }

  /**
   * Apply subscription discount display to cart items (15% with upsell in cart, 5% without)
   * Only applies to subscription items that are NOT app-only or auto-added
   */
  function applyCartSubscriptionDiscounts() {
    // First check if cart items exist at all
    const cartItemsTable = document.querySelector('.cart-items__table tbody');
    const priceContainers = document.querySelectorAll('.cart-item-price-container');

    if (priceContainers.length === 0) {
      return;
    }

    // First apply app-only free pricing
    applyAppOnlyFreePrice();

    // Check if upsell is in cart and calculate eligible total for tier
    const hasUpsellInCart = Array.from(priceContainers).some(c => c.dataset.isUpsell === 'true');
    let discountMultiplier = 0.95;
    let discountPct = 5;
    if (hasUpsellInCart) {
      discountMultiplier = 0.85;
      discountPct = 15;
    }

    priceContainers.forEach((container, index) => {
      // Catalog-prices items: Liquid already rendered exact metafield values — no JS overwrite needed
      if (container.dataset.usesCatalogPrices === 'true') return;

      const hasSellingPlan = container.dataset.hasSellingPlan === 'true';
      const hasSubscriptionProperty = container.dataset.hasSubscriptionProperty === 'true';
      const isAppOnly = container.dataset.isAppOnly === 'true';
      const isAutoAdded = container.dataset.isAutoAdded === 'true';
      const isFreeTrial = container.dataset.isFreeTrial === 'true';
      const isBundle = container.dataset.isBundle === 'true';
      const isUpsell = container.dataset.isUpsell === 'true';
      const taxRate = parseFloat(container.dataset.taxRate) || 0;
      const taxMultiplier = 1 + taxRate;
      const originalPrice = parseInt(container.dataset.originalPrice);
      const finalPrice = parseInt(container.dataset.finalPrice);

      // Item is a subscription if it has a selling plan OR has "Subscription: Yes" property
      const isSubscription = hasSellingPlan || hasSubscriptionProperty;

      // Subscription gets 5% without upsell; with upsell ALL eligible items get tiered discount
      const isEligibleForDiscount = (isSubscription || isBundle || hasUpsellInCart) && !isAppOnly && !isAutoAdded && !isFreeTrial && !isUpsell && originalPrice === finalPrice;
      // Eligible items (incl. bundles) get the tiered rate: 15% with the VIP upsell in cart, 5% without.
      const itemDiscountMultiplier = discountMultiplier;

      if (isEligibleForDiscount) {
        // Calculate discount (15% with upsell, 5% without)
        // No intermediate floor — multiply discount × tax in one step to match product page
        let discountedPrice = taxRate > 0
          ? Math.floor(originalPrice * itemDiscountMultiplier * taxMultiplier)
          : Math.floor(originalPrice * itemDiscountMultiplier);
        let displayOriginalPrice = taxRate > 0 ? Math.floor(originalPrice * taxMultiplier) : originalPrice;

        // Update display
        const finalPriceEl = container.querySelector('.cart-item-final-price');
        const originalPriceEl = container.querySelector('.cart-item-original-price');

        if (finalPriceEl) {
          finalPriceEl.textContent = formatMoney(discountedPrice);
          container.classList.add('has-subscription-discount');
        }

        // Show original price as strikethrough if not already shown
        if (!originalPriceEl && finalPriceEl) {
          const strikethrough = document.createElement('s');
          strikethrough.className = 'compare-at-price cart-item-original-price';
          strikethrough.textContent = formatMoney(displayOriginalPrice);
          finalPriceEl.parentNode.appendChild(strikethrough);
        } else if (originalPriceEl) {
          originalPriceEl.textContent = formatMoney(displayOriginalPrice);
        }

        // Update excl. VAT label to reflect discounted price (before tax)
        const exclVatPriceEl = container.parentElement?.querySelector('.cart-item-excl-vat-price');
        if (exclVatPriceEl) {
          exclVatPriceEl.textContent = formatMoney(Math.floor(originalPrice * itemDiscountMultiplier));
        }
      } else if (taxRate > 0 && !isAppOnly && !isAutoAdded && !isFreeTrial) {
        // Apply tax to non-discounted items
        const finalPriceEl = container.querySelector('.cart-item-final-price');
        const originalPriceEl = container.querySelector('.cart-item-original-price');
        const comparePriceEl = container.querySelector('.compare-at-price');

        if (finalPriceEl && !finalPriceEl.classList.contains('cart-item-free-price')) {
          const displayPrice = Math.floor((finalPrice || originalPrice) * taxMultiplier);
          finalPriceEl.textContent = formatMoney(displayPrice);
        }
        if (originalPriceEl) {
          originalPriceEl.textContent = formatMoney(Math.floor(originalPrice * taxMultiplier));
        }
        if (comparePriceEl && comparePriceEl !== originalPriceEl) {
          const comparePrice = parseInt(container.dataset.comparePrice) || originalPrice;
          comparePriceEl.textContent = formatMoney(Math.floor(comparePrice * taxMultiplier));
        }
      }

      // Update line total (text-component in .cart-items__price column) with discount + VAT
      var row = container.closest('.cart-items__table-row');
      if (row && !isAppOnly && !isAutoAdded && !isFreeTrial) {
        var lineTotalEl = row.querySelector('.cart-items__price text-component');
        if (lineTotalEl && (isEligibleForDiscount || taxRate > 0)) {
          var finalLinePrice = parseInt(container.dataset.finalLinePrice) || 0;
          var lineTotalCents;
          if (isEligibleForDiscount) {
            lineTotalCents = taxRate > 0
              ? Math.floor(finalLinePrice * itemDiscountMultiplier * taxMultiplier)
              : Math.floor(finalLinePrice * itemDiscountMultiplier);
          } else {
            lineTotalCents = taxRate > 0 ? Math.floor(finalLinePrice * taxMultiplier) : finalLinePrice;
          }
          lineTotalEl.textContent = formatMoney(lineTotalCents);
          lineTotalEl.setAttribute('value', formatMoney(lineTotalCents));
        }
      }

      // Add or remove VIP savings message based on upsell presence
      if (hasUpsellInCart && !isUpsell && !isAppOnly && !isAutoAdded && !isFreeTrial) {
        const existingSavings = container.querySelector('.cart-item-vip-savings');
        const savingsText = `You save ${discountPct}% with VIP Rewards`;
        if (existingSavings) {
          existingSavings.textContent = savingsText;
        } else {
          const savingsEl = document.createElement('span');
          savingsEl.className = 'cart-item-vip-savings';
          savingsEl.textContent = savingsText;
          container.appendChild(savingsEl);
        }
      } else {
        const existingSavings = container.querySelector('.cart-item-vip-savings');
        if (existingSavings) existingSavings.remove();
      }
    });

    // Compute subtotal from data attributes (single source of truth, idempotent)
    var subtotalCents = 0;
    var preTaxSubtotalCents = 0;
    var hasVatItems = false;
    priceContainers.forEach(function(c) {
      if (c.dataset.isAppOnly === 'true' || c.dataset.isFreeTrial === 'true') return;

      // Catalog-prices items: use pre-computed cents from metafield (no discount/tax calculation)
      if (c.dataset.usesCatalogPrices === 'true') {
        subtotalCents += parseInt(c.dataset.catalogLineCents) || 0;
        preTaxSubtotalCents += parseInt(c.dataset.catalogExclLineCents) || 0;
        if (c.dataset.catalogHasVat === 'true') hasVatItems = true;
        return;
      }

      var flp = parseInt(c.dataset.finalLinePrice) || 0;
      var isSub = c.dataset.hasSellingPlan === 'true' || c.dataset.hasSubscriptionProperty === 'true';
      var isAuto = c.dataset.isAutoAdded === 'true';
      var isUp = c.dataset.isUpsell === 'true';
      var eligible = (isSub || c.dataset.isBundle === 'true' || hasUpsellInCart) && !isAuto && !isUp
        && parseInt(c.dataset.originalPrice) === parseInt(c.dataset.finalPrice);
      // Eligible items (incl. bundles) get the tiered rate: 15% with the VIP upsell in cart, 5% without.
      var itemMult = discountMultiplier;
      var cTaxRate = parseFloat(c.dataset.taxRate) || 0;
      var cTaxMultiplier = 1 + cTaxRate;
      var discountedLine = eligible ? Math.floor(flp * itemMult) : flp;
      var lineCents;
      if (cTaxRate > 0 && !isAuto) {
        // No intermediate floor — multiply discount × tax in one step to match product page
        lineCents = eligible
          ? Math.floor(flp * itemMult * cTaxMultiplier)
          : Math.floor(flp * cTaxMultiplier);
        hasVatItems = true;
      } else {
        lineCents = discountedLine;
      }
      subtotalCents += lineCents;
      preTaxSubtotalCents += discountedLine;
    });

    var totalEl = document.querySelector('[ref="cartTotal"]');
    if (totalEl && subtotalCents > 0) {
      totalEl.textContent = formatMoney(subtotalCents);
      totalEl.setAttribute('value', formatMoney(subtotalCents));
    }

    // Update excl. VAT total in summary
    if (hasVatItems && preTaxSubtotalCents > 0) {
      var exclVatPriceTotalEl = document.querySelector('.cart__excl-vat-total-price');
      if (exclVatPriceTotalEl) {
        exclVatPriceTotalEl.textContent = formatMoney(preTaxSubtotalCents);
      }
    }
  }

  function formatMoney(cents) {
    var cc = window.data && window.data.countryConfig;
    var country = (window.data && window.data.profile && window.data.profile.targetCountry || '').toUpperCase();
    // Fallback: extract country from URL locale if window.data not ready yet
    if (!country) {
      var urlMatch = window.location.pathname.match(/^\/[a-z]{2}-([a-z]{2})(?:\/|$|\?)/i);
      if (urlMatch) country = urlMatch[1].toUpperCase();
    }
    // Infer currency symbol from country (symbol always shown on the left)
    var countrySymbolMap = { 'BE': '€', 'FR': '€', 'DE': '€', 'AT': '€', 'NL': '€', 'ES': '€', 'IT': '€', 'PT': '€', 'PL': 'zł', 'CZ': 'Kč', 'SK': '€', 'HU': 'Ft', 'RO': 'lei', 'HR': '€', 'BG': 'лв', 'SI': '€', 'CH': 'CHF', 'SE': 'kr', 'DK': 'kr', 'FI': '€', 'NO': 'kr', 'GB': '£', 'TR': '₺', 'CA': 'CA$' };
    var symbol = (cc && cc.currencySymbol) ? cc.currencySymbol : (countrySymbolMap[country] || '$');
    // Map country to proper locale so Intl.NumberFormat uses the correct decimal separator
    // EU countries use commas (e.g. €12,50), US/CA use dots (e.g. $12.50)
    var countryLocaleMap = { 'BE': 'fr-BE', 'FR': 'fr-FR', 'DE': 'de-DE', 'AT': 'de-AT', 'NL': 'nl-NL', 'ES': 'es-ES', 'IT': 'it-IT', 'PT': 'pt-PT', 'PL': 'pl-PL', 'CZ': 'cs-CZ', 'SK': 'sk-SK', 'HU': 'hu-HU', 'RO': 'ro-RO', 'HR': 'hr-HR', 'BG': 'bg-BG', 'SI': 'sl-SI', 'CH': 'de-CH', 'SE': 'sv-SE', 'DK': 'da-DK', 'FI': 'fi-FI', 'NO': 'nb-NO', 'GB': 'en-GB', 'TR': 'tr-TR', 'CA': 'en-CA' };
    var locale = countryLocaleMap[country] || 'en-US';
    // Format number only (no currency style) then prepend symbol so it always appears on the left
    var formatted = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    return symbol + formatted;
  }

  // Apply on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCartSubscriptionDiscounts);
  } else {
    applyCartSubscriptionDiscounts();
  }

  // Reapply when backend data loads (countryConfig becomes available for VAT)
  document.addEventListener('dmo:data:loaded', () => {
    applyCartSubscriptionDiscounts();
  });

  // Reapply when cart updates - use multiple strategies to catch all scenarios
  document.addEventListener('cart:update', (event) => {
    applyCartSubscriptionDiscounts();

    // Also try again after delays — the section morph (DOM update) happens
    // asynchronously AFTER the cart:update event fires, so we need to re-run
    // once the new data-final-line-price values are in the DOM.
    setTimeout(applyCartSubscriptionDiscounts, 200);
    setTimeout(applyCartSubscriptionDiscounts, 600);
  });

  // Listen for dialog open events (cart drawer opening)
  document.addEventListener('dialog:open', (event) => {
    const target = event.target;

    // Check if this is the cart drawer
    if (target && (target.id === 'cart-drawer' || target.tagName === 'CART-DRAWER-COMPONENT')) {
      // Apply immediately
      applyCartSubscriptionDiscounts();
      // And try again after a delay to ensure content is loaded
      setTimeout(applyCartSubscriptionDiscounts, 100);
      setTimeout(applyCartSubscriptionDiscounts, 300);
    }
  });

  // Listen for cart drawer refresh event (most reliable for AJAX add to cart)
  document.addEventListener('cart:drawer:refreshed', () => {
    // Apply immediately since DOM is now ready
    applyCartSubscriptionDiscounts();
    // Try again as backup
    setTimeout(applyCartSubscriptionDiscounts, 50);
    // Re-attach the MutationObserver to the new DOM element inserted by refreshCartDrawer()
    // (the old observer was watching a detached node after the component was replaced)
    setTimeout(observeCartChanges, 100);
  });

  // Watch for DOM changes in the cart continuously
  const observeCartChanges = () => {
    const cartWrapper = document.querySelector('.cart-items__wrapper') || 
                       document.querySelector('cart-items-component') ||
                       document.querySelector('.cart-items');
    
    if (!cartWrapper) {
      // Retry finding the cart element
      setTimeout(observeCartChanges, 500);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      let shouldReapply = false;
      
      mutations.forEach(mutation => {
        // Check for added nodes with price containers
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              // Check if this element has the price container class or contains one
              if (node.classList && node.classList.contains('cart-item-price-container')) {
                shouldReapply = true;
              } else if (node.classList && node.classList.contains('cart-items__table-row')) {
                shouldReapply = true;
              } else if (node.querySelector && node.querySelector('.cart-item-price-container')) {
                shouldReapply = true;
              }
            }
          });
        }
        
        // Check for attribute changes on price containers
        if (mutation.type === 'attributes' && 
            mutation.target.classList && 
            mutation.target.classList.contains('cart-item-price-container')) {
          shouldReapply = true;
        }
      });

      if (shouldReapply) {
        // Apply immediately when DOM changes
        applyCartSubscriptionDiscounts();
        normalizeCartDecimalSeparators();
        translateCartItemDetails();
        // And try again after a small delay as backup
        setTimeout(applyCartSubscriptionDiscounts, 100);
        setTimeout(normalizeCartDecimalSeparators, 100);
        setTimeout(translateCartItemDetails, 100);
      }
    });

    observer.observe(cartWrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      // data-final-line-price is what changes when quantity changes (unit price stays the same)
      attributeFilter: ['data-original-price', 'data-final-price', 'data-final-line-price']
    });
  };

  // Initialize observer when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartChanges);
  } else {
    observeCartChanges();
  }

  /**
   * Translate cart item product name and flavor using the same translations
   * metafield used on the product page (custom.translations per variant).
   */
  function translateCartItemDetails() {
    const pathname = window.location.pathname;
    const urlLocaleMatch = pathname.match(/^\/([a-z]{2}-[a-z]{2})(?:\/|$|\?)/i);
    if (!urlLocaleMatch) return;
    const locale = urlLocaleMatch[1];
    if (locale.toLowerCase().startsWith('en-')) return;

    const parts = locale.split('-');
    const variations = [
      locale,
      locale.toUpperCase(),
      locale.toLowerCase(),
      parts[0].toLowerCase() + '-' + (parts[1] || '').toUpperCase()
    ];

    function getField(translations, field) {
      if (!translations || typeof translations !== 'object') return null;
      for (var i = 0; i < variations.length; i++) {
        var entry = translations[variations[i]];
        if (entry) {
          var v = entry.variant && entry.variant[field];
          if (v && typeof v === 'string' && v.trim()) return v;
          var p = entry.product && entry.product[field];
          if (p && typeof p === 'string' && p.trim()) return p;
        }
      }
      return null;
    }

    document.querySelectorAll('.js-cart-item-translations').forEach(function(scriptEl) {
      var translations;
      try { translations = JSON.parse(scriptEl.textContent.trim()); } catch (e) { return; }
      if (!translations) return;

      var itemEl = scriptEl.closest('td') || scriptEl.parentElement;
      if (!itemEl) return;

      var productName = getField(translations, 'product_name');
      if (productName) {
        var titleEl = itemEl.querySelector('.cart-items__title');
        if (titleEl) titleEl.textContent = productName;
      }

      var flavour = getField(translations, 'flavour');
      if (flavour) {
        var flavorDiv = itemEl.querySelector('[data-cart-option-name="Flavor"], [data-cart-option-name="Flavour"]');
        if (flavorDiv) {
          var dd = flavorDiv.querySelector('dd');
          if (dd) {
            var suffix = dd.textContent.match(/[,\s\u00a0]+$/) ? dd.textContent.match(/[,\s\u00a0]+$/)[0] : '';
            dd.textContent = flavour + suffix;
          }
        }
      }
    });
  }

  /**
   * Translate subscription-related texts in cart items
   * Handles "Delivered every month." and "Early Access - Free Trial" texts
   */
  function translateCartSubscriptionTexts() {
    const pathname = window.location.pathname;
    const urlLocaleMatch = pathname.match(/^\/([a-z]{2}-[a-z]{2})(?:\/|$|\?)/i);
    const locale = urlLocaleMatch ? urlLocaleMatch[1].toLowerCase() : 'en-us';
    const language = locale.split('-')[0];

    if (language === 'en') return;

    // Self-contained translation tables — no dependency on external JS bundles
    const units = {
      de: { month: 'Monat',  months: 'Monate',   week: 'Woche',     weeks: 'Wochen',    day: 'Tag',    days: 'Tage'    },
      fr: { month: 'mois',   months: 'mois',     week: 'semaine',   weeks: 'semaines',  day: 'jour',   days: 'jours'   },
      es: { month: 'mes',    months: 'meses',     week: 'semana',    weeks: 'semanas',   day: 'día',    days: 'días'    },
      nl: { month: 'maand',  months: 'maanden',   week: 'week',      weeks: 'weken',     day: 'dag',    days: 'dagen'   },
      it: { month: 'mese',   months: 'mesi',      week: 'settimana', weeks: 'settimane', day: 'giorno', days: 'giorni'  },
      tr: { month: 'ay',     months: 'ay',        week: 'hafta',     weeks: 'hafta',     day: 'gün',    days: 'gün'     }
    };
    const everyWord  = { de: 'alle', fr: 'tous les', es: 'cada', nl: 'elke', it: 'ogni', tr: 'her' };
    const delivered  = { de: 'Geliefert', fr: 'Livré', es: 'Entregado', nl: 'Geleverd', it: 'Consegnato', tr: 'Teslim' };

    const earlyAccess = {
      fr: 'Accès anticipé - Essai gratuit',
      es: 'Acceso anticipado - Prueba gratuita',
      de: 'Frühzeitiger Zugang - Kostenlose Testversion',
      nl: 'Vroege toegang - Gratis proefversie',
      it: 'Accesso anticipato - Prova gratuita'
    };

    if (!units[language]) return;

    document.querySelectorAll('.cart-items__details').forEach(function(item) {
      item.querySelectorAll('p, li, dt, dd').forEach(function(el) {
        const text = el.textContent.trim();

        if (text === 'Early Access - Free Trial' && earlyAccess[language]) {
          el.textContent = earlyAccess[language];
          return;
        }

        // "Delivered every (N )?(unit)." — e.g. "Delivered every month." / "Delivered every 2 months."
        const m = text.match(/^Delivered every (?:(\d+) )?(day|days|week|weeks|month|months|year|years)\.?$/i);
        if (!m) return;

        const num      = m[1] ? parseInt(m[1]) : 1;
        const unitRaw  = m[2].toLowerCase();
        const unitKey  = num === 1 ? unitRaw.replace(/s$/, '') : (unitRaw.endsWith('s') ? unitRaw : unitRaw + 's');
        const unit     = (units[language] || {})[unitKey] || unitRaw;
        const every    = everyWord[language] || '';
        const dlvd     = delivered[language] || '';
        if (!unit || !every || !dlvd) return;

        el.textContent = num === 1
          ? dlvd + ' ' + every + ' ' + unit + '.'
          : dlvd + ' ' + every + ' ' + num + ' ' + unit + '.';
      });
    });
  }

  // Apply translations on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      translateCartItemDetails();
      translateCartSubscriptionTexts();
    });
  } else {
    translateCartItemDetails();
    translateCartSubscriptionTexts();
  }

  // Reapply translations when cart updates — DOM morph happens asynchronously after the event
  document.addEventListener('cart:update', () => {
    setTimeout(function() { translateCartItemDetails(); translateCartSubscriptionTexts(); }, 100);
    setTimeout(function() { translateCartItemDetails(); translateCartSubscriptionTexts(); }, 400);
    setTimeout(function() { translateCartItemDetails(); translateCartSubscriptionTexts(); }, 800);
    setTimeout(function() { translateCartItemDetails(); translateCartSubscriptionTexts(); }, 1500);
    setTimeout(function() { translateCartItemDetails(); translateCartSubscriptionTexts(); }, 3000);
  });

  /**
   * Truncates all cart prices to exactly 2 decimal places without rounding
   * Processes all price elements in the cart to ensure consistent truncation
   */
  function truncateCartPrices() {
    // Skip truncation for VAT countries - VAT scripts handle formatting via Intl.NumberFormat
    if (window.data && window.data.countryConfig && window.data.countryConfig.displayVatInclusive) return;

    // Helper function to round to 2 decimal places (nearest cent)
    function truncateToTwoDecimals(num) {
      return Math.floor(num * 100) / 100;
    }

    // Helper function to parse price from formatted string (e.g., "$95.99" -> 95.99)
    function parsePriceFromString(priceString) {
      // Remove currency symbols, commas, and whitespace
      const cleaned = priceString.replace(/[$,\s]/g, '');
      return parseFloat(cleaned);
    }

    // Helper function to format price with currency symbol
    function formatPrice(amount, currencySymbol) {
      const truncated = truncateToTwoDecimals(amount);
      return currencySymbol + truncated.toFixed(2);
    }

    // Get current locale to determine currency symbol
    const pathname = window.location.pathname;
    const urlLocaleMatch = pathname.match(/^\/([a-z]{2}-[a-z]{2})(?:\/|$|\?)/);
    const locale = urlLocaleMatch ? urlLocaleMatch[1] : 'en-us';
    const country = locale.split('-')[1]?.toUpperCase();
    const currencySymbol = country === 'CA' ? 'CA$' : '$';

    // Find all price elements in cart
    const priceSelectors = [
      '.cart-item-final-price:not(.cart-item-free-price)',
      '.cart-item-original-price',
      '.cart-items__price text-component',
      '.cart-subtotal-price',
      '.cart-total-price'
    ];

    priceSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);

      elements.forEach(el => {
        const priceText = el.textContent.trim();

        // Skip if already "FREE" (or translated equivalent) or empty
        const freeText = window.cartTranslations?.free || 'FREE';
        if (!priceText || priceText === freeText || priceText === 'FREE' || priceText === '$0.00' || priceText === 'CA$0.00') {
          return;
        }

        // Parse the price
        const priceValue = parsePriceFromString(priceText);

        // Skip if parsing failed
        if (isNaN(priceValue)) {
          return;
        }

        // Format with truncation
        const truncatedPrice = formatPrice(priceValue, currencySymbol);

        // Update the element
        el.textContent = truncatedPrice;
      });
    });
  }

  // Apply truncation on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(truncateCartPrices, 150);
    });
  } else {
    setTimeout(truncateCartPrices, 150);
  }

  // Reapply truncation when cart updates
  document.addEventListener('cart:update', () => {
    setTimeout(truncateCartPrices, 150);
  });

  // Reapply when cart drawer opens
  document.addEventListener('dialog:open', (event) => {
    const target = event.detail?.target || event.target;
    if (target && (target.id === 'cart-drawer' || target.tagName === 'CART-DRAWER-COMPONENT')) {
      setTimeout(translateCartSubscriptionTexts, 150);
      setTimeout(truncateCartPrices, 200);
    }
  });

  // Reapply when cart drawer is refreshed
  document.addEventListener('cart:drawer:refreshed', () => {
    setTimeout(translateCartSubscriptionTexts, 100);
    setTimeout(truncateCartPrices, 150);
  });

  /**
   * Normalize Liquid-rendered prices in the cart to use dots instead of commas.
   * Shopify's | money filter outputs commas for European currency formats (e.g. €10,99).
   * Skip US and CA — they already use dot notation.
   */
  function normalizeCartDecimalSeparators() {
    // Skip for VAT countries — formatMoney() already uses Intl.NumberFormat with the correct
    // locale (commas as decimal separator), so converting commas→dots would break display.
    if (window.data && window.data.countryConfig && window.data.countryConfig.displayVatInclusive) return;

    // Try window.data first; fall back to Liquid-rendered data-country attribute
    // (window.data may not be available on first cart open before DMO script loads)
    var country = (window.data && window.data.profile && window.data.profile.targetCountry || '').toUpperCase();
    if (!country) {
      var wrapper = document.querySelector('.cart-items__wrapper[data-country]');
      if (wrapper) country = wrapper.getAttribute('data-country').toUpperCase();
    }
    if (!country || country === 'US' || country === 'CA') return;

    // Also skip for EU/comma-decimal countries even if DMO data hasn't loaded yet.
    // These countries use commas as decimal separators and must not be converted to dots.
    var commaDecimalCountries = ['FR','DE','IT','AT','BE','NL','ES','PT','CH','GB','PL','SE','NO','DK','FI','SK','HU','RO','HR','BG','SI','TR'];
    if (commaDecimalCountries.indexOf(country) !== -1) return;

    var selectors = [
      '.cart__original-total-value',
      '.cart__discount-value',
      '.cart__excl-vat-total-price',
      '.cart-item-final-price',
      '.cart-item-original-price',
      '.cart-item-excl-vat-price',
      '[ref="cartTotal"]',
      '.cart-items__price text-component',
    ].join(', ');

    document.querySelectorAll(selectors).forEach(function(el) {
      // Read textContent (works whether price is a plain text node or wrapped in
      // a Shopify <span class="money">...</span> from the | money Liquid filter)
      var text = el.textContent;
      if (!text || !/\d,\d{2}/.test(text)) return;
      // Step 1: thousands dot (e.g. 1.234,56 → 1,234,56) → convert to comma
      // Step 2: decimal comma (e.g. 10,99 or 1,234,56 ending) → convert to dot
      var normalized = text
        .replace(/(\d)\.(\d{3})(?=[,\D]|$)/g, '$1,$2')
        .replace(/(\d),(\d{2})(?=\D|$)/g, '$1.$2');
      if (normalized === text) return;
      // Setting textContent removes any inner Shopify <span class="money"> wrapper —
      // this is intentional and consistent with what applyCartSubscriptionDiscounts does.
      el.textContent = normalized;
      // Also sync the value attribute used by text-component / payment_terms
      if (el.hasAttribute('value')) el.setAttribute('value', normalized);
    });
  }

  // Wire up normalizer to the same events as truncateCartPrices
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(normalizeCartDecimalSeparators, 160);
    });
  } else {
    setTimeout(normalizeCartDecimalSeparators, 160);
  }

  document.addEventListener('cart:update', () => {
    setTimeout(normalizeCartDecimalSeparators, 160);
  });

  document.addEventListener('dialog:open', (event) => {
    const target = event.detail?.target || event.target;
    if (target && (target.id === 'cart-drawer' || target.tagName === 'CART-DRAWER-COMPONENT')) {
      normalizeCartDecimalSeparators();
      setTimeout(normalizeCartDecimalSeparators, 100);
      setTimeout(normalizeCartDecimalSeparators, 300);
    }
  });

  document.addEventListener('cart:drawer:refreshed', () => {
    normalizeCartDecimalSeparators();
    setTimeout(normalizeCartDecimalSeparators, 100);
    setTimeout(normalizeCartDecimalSeparators, 400);
  });

  document.addEventListener('cart:added', () => {
    setTimeout(normalizeCartDecimalSeparators, 200);
    setTimeout(normalizeCartDecimalSeparators, 600);
  });

  /**
   * Ensure all cart prices always show exactly 2 decimal places.
   * Catches cases like €25,3 (from catalog_prices metafield) → €25,30.
   */
  function padCartPriceDecimals() {
    var selectors = [
      '.cart-item-final-price',
      '.cart-item-original-price',
      '.cart-item-excl-vat-price',
      '.cart__original-total-value',
      '.cart__discount-value',
      '.cart__excl-vat-total-price',
      '[ref="cartTotal"]',
      '.cart-items__price text-component',
    ].join(', ');

    document.querySelectorAll(selectors).forEach(function(el) {
      var text = el.textContent.trim();
      if (!text) return;
      // Pad prices with exactly 1 decimal digit: €25,3 → €25,30
      var padded = text.replace(/(\d),(\d)(?!\d)/g, '$1,$20');
      if (padded !== text) el.textContent = padded;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { setTimeout(padCartPriceDecimals, 170); });
  } else {
    setTimeout(padCartPriceDecimals, 170);
  }
  document.addEventListener('cart:update', () => { setTimeout(padCartPriceDecimals, 170); });
  document.addEventListener('cart:added', () => { setTimeout(padCartPriceDecimals, 210); setTimeout(padCartPriceDecimals, 610); });
  document.addEventListener('cart:drawer:refreshed', () => { padCartPriceDecimals(); setTimeout(padCartPriceDecimals, 110); setTimeout(padCartPriceDecimals, 410); });
  document.addEventListener('dialog:open', (event) => {
    const target = event.detail?.target || event.target;
    if (target && (target.id === 'cart-drawer' || target.tagName === 'CART-DRAWER-COMPONENT')) {
      padCartPriceDecimals();
      setTimeout(padCartPriceDecimals, 110);
      setTimeout(padCartPriceDecimals, 310);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["faqs-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var FAQS_HASH = '#faqs';
    var ACTIVE_CLASS = 'product-modal--active';

    var faqs = {
      tabs: {
        general: {
          label: 'General',
          items: []
        }
      }
    };

    window.faqs = faqs;

    /**
     * Santizes mangled html form AEM
     * @param {string} html - The html to sanitize
     * @returns {string} The sanitized html
     */
    function sanitizeHtml(html) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = html;
      let decoded = textarea.value;

      decoded = decoded.replace(/\\r\\n/g, '');
      decoded = decoded.replace(/\r\n/g, '');

      return decoded;
    }

    function normalizeAemFaqItem(entry) {
      if (!entry || typeof entry !== 'object') return null;

      var question = entry.question;
      var answer = sanitizeHtml(entry.answer);
      if (!question) return null;

      return { question: question, answer: answer || '' };
    }

    function getAemFaqsSource(aem) {
      return aem && aem['shopify/faq-general'];
    }

    class FaqsModalElement extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        var signal = this.abortController.signal;

        this.closeButton = this.querySelector('.faqs-modal__close');
        this.backdrop = this.querySelector('.faqs-modal__backdrop');
        this.titleEl = this.querySelector('[data-faqs-title]');
        this.tabsRoot = this.querySelector('[data-faqs-tabs]');
        this.tabsList = this.querySelector('[data-faqs-tabs-list]');
        this.panelsRoot = this.querySelector('[data-faqs-panels]');
        this.tabs = [];
        this.panels = [];

        this.handleCloseClick = this.close.bind(this);
        this.handleDocumentClick = function (event) {
          var trigger = event.target.closest('a[href="#faqs"]');
          if (trigger) this.open(event);
        }.bind(this);
        this.handleKeyDown = function (event) {
          if (event.key === 'Escape' && this.isOpen) this.close();
        }.bind(this);
        this.handleHashChange = function () {
          if (window.location.hash === FAQS_HASH) {
            this.open();
          } else if (this.isOpen) {
            this.close();
          }
        }.bind(this);
        this.handleBackdropClick = function (event) {
          if (event.target === this.backdrop) this.close();
        }.bind(this);
        this.handleAemDataLoaded = function (event) {
          this.loadAemFaqs(event.detail || window.dataAEM);
        }.bind(this);

        this.attachEvents(signal);

        if (window.dataAEM) {
          this.loadAemFaqs(window.dataAEM);
        } else {
          document.addEventListener('aem:data:loaded', this.handleAemDataLoaded, { once: true, signal: signal });
        }

        if (window.location.hash === FAQS_HASH) {
          this.open();
        }
      }

      disconnectedCallback() {
        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
      }

      get isOpen() {
        return this.classList.contains(ACTIVE_CLASS);
      }

      open(event) {
        if (event) event.preventDefault();

        this.classList.add(ACTIVE_CLASS);
        this.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        if (window.location.hash !== FAQS_HASH) {
          history.replaceState(null, '', window.location.pathname + window.location.search + FAQS_HASH);
        }
      }

      close() {
        this.classList.remove(ACTIVE_CLASS);
        this.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        if (window.location.hash === FAQS_HASH) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
      }

      loadAemFaqs(aem) {
        const source = getAemFaqsSource(aem);
        const list = source && source['faq-list'];


        if (this.titleEl && source) {
          this.titleEl.textContent = (typeof source.title === 'string' && source.title) ? source.title : 'title';
        }

        if (!Array.isArray(list)) return;

        window.faqs.tabs.general.items = list
          .map(normalizeAemFaqItem)
          .filter(Boolean);

        this.renderFaqs(window.faqs);
        this.initTabs(this.abortController && this.abortController.signal);
      }

      renderFaqs(data) {
        if (!this.tabsList || !this.panelsRoot || !data || !data.tabs) return;

        var tabs = Object.keys(data.tabs).map(function (id) {
          var tab = data.tabs[id];
          return { id: id, label: tab.label, items: tab.items };
        }).filter(function (tab) {
          return tab && Array.isArray(tab.items) && tab.items.length > 0;
        });

        this.tabsList.innerHTML = '';
        this.panelsRoot.innerHTML = '';

        if (!tabs.length) return;

        var showTabs = tabs.length > 1;
        this.tabsList.hidden = !showTabs;

        tabs.forEach(function (tab, index) {
          var tabId = tab.id || ('tab-' + index);
          var isFirst = index === 0;

          if (showTabs) {
            var tabButton = document.createElement('button');
            tabButton.type = 'button';
            tabButton.className = 'faqs-modal__tab' + (isFirst ? ' is-active' : '');
            tabButton.setAttribute('role', 'tab');
            tabButton.id = 'faqs-tab-' + tabId;
            tabButton.setAttribute('aria-selected', isFirst ? 'true' : 'false');
            tabButton.setAttribute('aria-controls', 'faqs-panel-' + tabId);
            tabButton.setAttribute('data-faqs-tab', tabId);
            tabButton.textContent = tab.label || tabId;
            this.tabsList.appendChild(tabButton);
          }

          var panel = document.createElement('div');
          panel.className = 'faqs-modal__panel' + (isFirst ? ' is-active' : '');
          panel.setAttribute('role', 'tabpanel');
          panel.id = 'faqs-panel-' + tabId;
          panel.setAttribute('aria-labelledby', 'faqs-tab-' + tabId);
          panel.setAttribute('data-faqs-panel', tabId);
          if (!isFirst) panel.hidden = true;

          var accordion = document.createElement('div');
          accordion.className = 'faq-accordion faqs-modal__faqs';

          var list = document.createElement('ul');
          list.className = 'faq-accordion__list';

          tab.items.forEach(function (item) {
            var accordionItem = this.createAccordionItem(item);
            if (accordionItem) list.appendChild(accordionItem);
          }, this);

          accordion.appendChild(list);
          panel.appendChild(accordion);
          this.panelsRoot.appendChild(panel);
        }, this);
      }

      cloneAccordionIcon() {
        if (!this.accordionIconTemplate) {
          this.accordionIconTemplate = this.querySelector('[data-faq-accordion-icon-template]');
        }

        var icon = this.accordionIconTemplate && this.accordionIconTemplate.content.firstElementChild;
        return icon ? icon.cloneNode(true) : null;
      }

      createAccordionItem(item) {
        if (!item || !item.question) return null;

        var li = document.createElement('li');
        li.className = 'faq-accordion__item';

        var details = document.createElement('details');
        details.className = 'faq-accordion__details';

        var summary = document.createElement('summary');
        summary.className = 'faq-accordion__summary';

        var icon = this.cloneAccordionIcon();
        if (icon) summary.appendChild(icon);

        var title = document.createElement('span');
        title.className = 'faq-accordion__item-title';
        title.textContent = item.question;
        summary.appendChild(title);

        var body = document.createElement('div');
        body.className = 'faq-accordion__item-body';

        var answer = item.answer || '';
        if (/<[^>]+>/.test(answer)) {
          body.innerHTML = answer;
        } else {
          var paragraph = document.createElement('p');
          paragraph.textContent = answer;
          body.appendChild(paragraph);
        }

        details.appendChild(summary);
        details.appendChild(body);
        li.appendChild(details);

        return li;
      }

      initTabs(signal) {
        if (!this.tabsRoot) return;

        var self = this;
        this.tabs = Array.prototype.slice.call(this.tabsRoot.querySelectorAll('[data-faqs-tab]'));
        this.panels = Array.prototype.slice.call(this.tabsRoot.querySelectorAll('[data-faqs-panel]'));

        this.tabs.forEach(function (tab, index) {
          tab.addEventListener('click', function () {
            self.activateTab(index);
          }, signal ? { signal: signal } : undefined);
        });
      }

      activateTab(index) {
        if (index < 0 || index >= this.tabs.length) return;

        var tab = this.tabs[index];
        var target = tab.getAttribute('data-faqs-tab');

        this.tabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-faqs-panel') === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        if (window.matchMedia('(max-width: 768px)').matches) {
          tab.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
        }
      }

      attachEvents(signal) {
        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.handleCloseClick, { signal: signal });
        }
        if (this.backdrop) {
          this.backdrop.addEventListener('click', this.handleBackdropClick, { signal: signal });
        }
        document.addEventListener('keydown', this.handleKeyDown, { signal: signal });
        document.addEventListener('click', this.handleDocumentClick, { signal: signal });
        window.addEventListener('hashchange', this.handleHashChange, { signal: signal });
      }
    }

    if (!customElements.get('faqs-modal')) {
      customElements.define('faqs-modal', FaqsModalElement);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid"] && !Shopify.designMode) return;
  try {
    function updateUrlParameter(url, param, value) {
    const urlObj = new URL(url);
    urlObj.searchParams.set(param, value);
    return urlObj.toString();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["profile-prominent"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const toggleButton = document.querySelector('[data-profile-toggle]');
    const profileDetails = document.querySelector('[data-profile-details]');

    if (toggleButton && profileDetails) {
      toggleButton.addEventListener('click', function() {
        const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

        // Toggle aria-expanded attribute
        toggleButton.setAttribute('aria-expanded', !isExpanded);

        // Toggle the visibility class
        if (isExpanded) {
          profileDetails.classList.remove('show');
          profileDetails.style.display = 'none';
        } else {
          profileDetails.style.display = 'flex';
          // Use setTimeout to ensure display change takes effect before animation
          setTimeout(() => {
            profileDetails.classList.add('show');
          }, 10);
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
